module.exports = __webpack_public_path__ + "img/facebook-2.00a9808d.svg";